export { default } from "./Private";



// WEBPACK FOOTER //
// ./src/containers/Private/index.js